// extracted by mini-css-extract-plugin
export default {"sectionTitle":"CompanyFieldset_sectionTitle__YxDsa","introText":"CompanyFieldset_introText__wh2wI","isActiveSwitch":"CompanyFieldset_isActiveSwitch__69ruc"};